module.exports = __webpack_public_path__ + "static/media/img-poster-bg.41721919.png";